<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import UsersList from "@/router/views/customer-admin/customer-user-list";


export default {
  page: {
    title: "Gestion des abonnements",
    meta: [{ name: "description", content: appConfig.description }]
  },

  props: {
    customerId:{
          type:(Number),
          default:null
      },
    },

  components: { Layout,UsersList},
  data() {
    return {
        hasCustomerUserManagementAccess:false,

    };
  }, 
    mounted(){
      
        this.hasCustomerUserManagementAccess= true; // this.privileges.includes(Priviliges[0]["Customer_User_Management"] )
     

  },
    methods: {
      
    }
}; 
</script>
<template>
  <Layout>
    <div class="row pt-4 p-sm-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title font-size-25" style="font-size:25px;">{{$t('subscription.cardTitle')}}</h2>
             <p class="card-title-desc font-size-14">
            </p>
             <b-tabs content-class="p-3 text-muted">
              <b-tab v-if="hasCustomerUserManagementAccess" lazy>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-user font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-user font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('subscription.customers')}}</span>
                  </template>
                  <UsersList :customerId="customerId" />
                </b-tab>
                
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>